import { observer } from 'mobx-react';
import IncorrectIcon from '../Cutesies/IncorrectIcon';
import Checkmark from '../Cutesies/Checkmark';
import { when } from '@execonline-inc/maybe-adapter';
import { equals } from '@execonline-inc/collections';

interface Props {
  value: boolean;
}

function ShowOnOffIcons({ value }: Props) {
  return when(equals(value, true), {})
    .map(() => <Checkmark className="fill-teal-600 mt-1 h-[11px] w-[19px]" />)
    .getOrElse(() => <IncorrectIcon />);
}

export default observer(ShowOnOffIcons);
